// @flow

import * as React from 'react'
import moment from 'moment'
// $FlowFixMe
import 'moment/locale/it'
import { Loader, Dimmer } from 'semantic-ui-react'
import { connect, type Connector } from 'react-redux'

import {
  toggleFilter,
  setChartSampling,
  setChartType,
  setChartBrushState,
  getDailyData,
  getWeeklyData,
  getMonthlyData,
} from '../store/reports'
import AreaChart from './area-chart.js'
import LineChart from './line-chart.js'

import ChartSamplingToolbar from './chart-sampling-toolbar'
import ChartTypeToolbar from './chart-type-toolbar'
import ChartFilterToolbar from './chart-filter-toolbar'
import Slider from './slider'

import type { ReduxState, Dispatch } from '../store'
import type { ChartType, ChartSampling, BrushState, AggregatedVisits } from '../store/reports'

type OwnProps = {||}

type MappedProps = {|
  currentCampaign: string,
  status: string,
  showWeb: boolean,
  showPhone: boolean,
  showF2F: boolean,
  chartSampling: ChartSampling,
  chartType: ChartType,
  chartBrushState: BrushState,
  data: AggregatedVisits,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let dates = Object.keys(state.reports.ui.data ? state.reports.ui.data : {}).map(d => parseInt(d, 10))
  let startDate = moment(Math.min(...dates).toString(), 'YYYYMMDD')
  let lastDate = moment(Math.max(...dates).toString(), 'YYYYMMDD')
  // CUTOFF FUTURE DATES
  let endDate = lastDate.isBefore(moment()) ? lastDate : moment()

  let data = []
  if (state.reports.ui.chartSampling === 'DAILY') {
    data = getDailyData(state, startDate, endDate)
  } else if (state.reports.ui.chartSampling === 'WEEKLY') {
    data = getWeeklyData(state, startDate, endDate)
  } else if (state.reports.ui.chartSampling === 'MONTHLY') {
    data = getMonthlyData(state, startDate, endDate)
  }

  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    status: state.reports.ui.loading,
    showWeb: state.reports.ui.showWeb,
    showPhone: state.reports.ui.showPhone,
    showF2F: state.reports.ui.showF2F,
    chartSampling: state.reports.ui.chartSampling,
    chartType: state.reports.ui.chartType,
    chartBrushState: state.reports.ui.chartBrushState,
    data,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps
class TemporalSeries extends React.Component<Props> {
  static defaultProps = {}

  renderSliderTooltip = index => {
    return this.props.data[index] ? this.props.data[index].name : ''
  }

  onToggleFilter = (value: 'web' | 'phone' | 'f2f') => {
    this.props.dispatch(toggleFilter(value))
  }

  onChangeSampling = (chartSampling: ChartSampling) => {
    this.props.dispatch(setChartSampling(chartSampling))
  }

  onChangeChartRange = (values: [number, number]) => {
    this.props.dispatch(setChartBrushState({ startIndex: values[0], endIndex: values[1] }))
  }

  onChangeChartType = (type: ChartType) => {
    this.props.dispatch(setChartType(type))
  }

  render() {
    let graphProps = {
      data: this.props.data,
      startIndex: this.props.chartBrushState.startIndex,
      endIndex: this.props.chartBrushState.endIndex,
      showWeb: this.props.showWeb,
      showPhone: this.props.showPhone,
      showF2F: this.props.showF2F,
      width: '100%',
      height: '95%',
    }

    return (
      <Dimmer.Dimmable
        dimmed={this.props.status === 'NEW' || this.props.status === 'PENDING'}
        className="main-container">
        <Dimmer
          active={this.props.status === 'NEW' || this.props.status === 'PENDING'}
          inverted
          style={{ zIndex: 700 }}>
          {this.props.status === 'PENDING' && <Loader />}
        </Dimmer>
        <div className="ui column grid">
          <div className="column">
            <div style={{ float: 'left' }}>
              <ChartSamplingToolbar chartSampling={this.props.chartSampling} onChangeSampling={this.onChangeSampling} />
            </div>
            <div style={{ float: 'left', marginLeft: '1rem' }}>
              <ChartTypeToolbar chartType={this.props.chartType} onChangeType={this.onChangeChartType} />
            </div>
            <div style={{ float: 'right', textAlign: 'right' }}>
              <ChartFilterToolbar
                showWeb={this.props.showWeb}
                showPhone={this.props.showPhone}
                showF2F={this.props.showF2F}
                onToggleFilter={this.onToggleFilter}
              />
            </div>
          </div>
        </div>
        <div
          className="ui seven column grid calendar-grid"
          style={{
            flexGrow: 1,
            padding: '3rem 4rem 2rem 0rem',
            border: 'solid 1px #d9d9d9',
            backgroundColor: 'white',
            height: '100%' /* FIX ResponsiveContainer on Chrome */,
          }}>
          {this.props.data.length > 0 && this.props.chartType === 'AREA' && <AreaChart {...graphProps} />}
          {this.props.data.length > 0 && this.props.chartType === 'LINE' && <LineChart {...graphProps} />}
          {this.props.data.length > 0 && (
            <div style={{ width: '100%', marginLeft: '3.5rem', marginTop: '-1.5rem' }}>
              <Slider
                min={0}
                max={this.props.data.length - 1}
                onAfterChange={this.onChangeChartRange}
                tipFormatter={this.renderSliderTooltip}
              />
            </div>
          )}
        </div>
      </Dimmer.Dimmable>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(TemporalSeries)



// WEBPACK FOOTER //
// ./src/reports/temporal-series.js